import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useTerrariumStore } from '../store/terrariumStore'
import useSettingsStore from '../store/settingsStore'
import useBitsStore from '../store/bitsStore'
import { useTwitchConnection } from '../hooks/useTwitchConnection'
import WideTerrariumScene from '../components/WideTerrariumScene'
import StatusDisplay from '../components/StatusDisplay'
import AuthPrompt from '../components/AuthPrompt'
import SettingsPanel from '../components/SettingsPanel'
import '../styles/App.css'

function Overlay() {
  const { broadcasterLogin } = useParams()
  const { status, needsAuth, authUrl, connect, openAuthPopup } = useTwitchConnection(broadcasterLogin)
  const loadFromApi = useTerrariumStore((state) => state.loadFromApi)
  const setBroadcasterLogin = useTerrariumStore((state) => state.setBroadcasterLogin)
  const loadSettings = useSettingsStore((state) => state.loadFromApi)
  const setSettingsBroadcaster = useSettingsStore((state) => state.setBroadcasterLogin)
  const setBitsBroadcaster = useBitsStore((state) => state.setBroadcasterLogin)

  useEffect(() => {
    if (broadcasterLogin) {
      setBroadcasterLogin(broadcasterLogin)
      setSettingsBroadcaster(broadcasterLogin)
      setBitsBroadcaster(broadcasterLogin)
      loadFromApi(broadcasterLogin)
      loadSettings(broadcasterLogin)
      connect()
    }
  }, [broadcasterLogin, loadFromApi, setBroadcasterLogin, loadSettings, setSettingsBroadcaster, setBitsBroadcaster, connect])

  if (!broadcasterLogin) {
    return (
      <div className="overlay" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
        <p>Missing broadcaster login in URL</p>
      </div>
    )
  }

  return (
    <div className="overlay terrarium-overlay">
      <WideTerrariumScene />
      {needsAuth && <AuthPrompt authUrl={authUrl} onAuth={openAuthPopup} />}
      <StatusDisplay status={status} needsAuth={needsAuth} />
      <SettingsPanel isAdmin={true} broadcasterLogin={broadcasterLogin} />
    </div>
  )
}

export default Overlay